export default __webpack_public_path__ + "static/media/include_16@2x.e8659fa9.jpg";